<div class="radius-huge surface-elevated w-100 h-100 p-plus d-flex flex-column">
  <lib-ngx-skeleton-loading
    [classes]="'mb-medium'"
    [width]="'51px'"
    [height]="'16px'"
    [borderRadius]="'50px'"
  ></lib-ngx-skeleton-loading>

  <lib-ngx-skeleton-loading
    [classes]="'mb-tiny'"
    [width]="'132px'"
    [height]="'32px'"
    [borderRadius]="'50px'"
  ></lib-ngx-skeleton-loading>

  <lib-ngx-skeleton-loading
    [classes]="'mb-plus'"
    [width]="'136px'"
    [height]="'24px'"
    [borderRadius]="'50px'"
  ></lib-ngx-skeleton-loading>

  <div class="d-flex justify-content-end">
    <lib-ngx-skeleton-loading
      [classes]="'mb-big'"
      [width]="'63px'"
      [height]="'16px'"
      [borderRadius]="'50px'"
    ></lib-ngx-skeleton-loading>
  </div>

  <lib-ngx-skeleton-loading
    [width]="'280px'"
    [height]="'48px'"
    [borderRadius]="'50px'"
  ></lib-ngx-skeleton-loading>
</div>
